<template>
  <vue-html2pdf
    :show-layout="false"
    :float-layout="false"
    :enable-download="true"
    :preview-modal="true"
    :paginate-elements-by-height="1900"
    pdf-content-width="480px"
    :filename="fileName"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    ref="html2PdfQr"
    :html-to-pdf-options="htmlToPdfOptions"
    @hasDownloaded="hasDownloaded()"
  >
    <template slot="pdf-content">
      <div>
        <div
          class="product-card html2pdf__page-break"
          :style="{
            '--background': vg_activeBusinessBrandingAndLogo.primary,
            // 'margin-bottom': index === productsData.length - 1 ? '0px' : '708px'
          }"
          v-for="(item, index) in productsData"
          :key="index"
        >
            <div  v-bind:key="'pdf-qr-only'+variant.id" v-for="variant in item.variants">
              <div class="qr-container" style="width:150px">
                <qrcode-vue :value="getQrCodeValue(item.id)" :size="150" />
                <div style="text-align:center;margin-top:15px;font-size: 22px; margin-bottom: 15px;">
                    {{variant.size ? variant.size + ': ': ''}}${{ (variant.sale_price && (variant.sale_price < variant.price)) ? variant.sale_price.toFixed(2) : variant.price >= 0 ? variant.price.toFixed(2) : 'N/A' }}
                </div>
              </div>
            </div>
          <!-- <div class="qr-container">
            <qrcode-vue :value="getQrCodeValue(item.id)" :size="300" />
            <img :src="logo" height="50" width="50" class="qrcode_image" />
          </div>
          <div class="price">
            {{ getPrice(item) }}
          </div> -->
        </div>
      </div>
    </template>
  </vue-html2pdf>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import VueHtml2pdf from 'vue-html2pdf'
import { mapGetters } from 'vuex'
export default {
  name: 'QrToHtml',
  components: {
    VueHtml2pdf,
    QrcodeVue
  },
  props: ['productsData'],
  data() {
    return {
      logo: require('@/assets/images/Rectangle.jpg')
    }
  },
  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo',
      vg_selectedLocation: 'location/selected',
      vg_selectedBusiness: 'auth/activeBusiness'
    }),
    htmlToPdfOptions() {
      return {
        margin: [2, 0, 0, 0],
        filename: `${this.fileName}.pdf`,
        // image: { type: 'png', quality: 1 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          useCORS: true,
          dpi: 192,
          scale: 2,
          letterRendering: true
        }
      }
    },
    fileName() {
      return `products-card.pdf`
    }
  },
  methods: {
    getQrCodeValue(value) {
      return (
        process.env.VUE_APP_PRODUCT_QR_URL +
        '/' +
        this.vg_selectedBusiness.slug +
        '/' +
        this.vg_selectedLocation.slug +
        '/' +
        value +
        '?in_store=true&noage=true'
      )
    },
    hasDownloaded() {
      this.$emit('hasDownloaded')
    },
    generatePdf() {
      this.$refs.html2PdfQr.generatePdf()
    },
    getPrice(val) {
      let allPrices = []
      let allSizes = []
      if (val.variants.length === 0) {
        return ''
      }
      val.variants.map(variant => {
        allPrices.push(variant.price)
        if (variant.size && variant.size !== '') {
          allSizes.push(variant.size)
        }
      })
      let value = Math.min(...allPrices)
      return '$ ' + value
    }
  }
}
</script>
<style scoped lang="scss">
.price{
  height: 50px;
  font-size: 30px;
  margin-top: 12px;
  padding-left: 140px;
}
.qr-container {
  margin-left: 32px;
  margin-top: 40px;
  margin-bottom: 0;
  display: inline-block;
  position: relative;
  .qrcode_image {
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
    height: 15%;
    left: 50%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 15%;
  }
}
</style>
